import { projectRequest } from 'store/utils/request';

export const getRuleGroupsListRequest = async params => {
  try {
    return await projectRequest.get(`/rule_groups/`, {
      params: {
        ...params,
      },
    });
  } catch (error) {
    throw error;
  }
};

export const addRuleGroupsRequest = async data => {
  try {
    return await projectRequest.post(`/rule_groups/`, data);
  } catch (error) {
    throw error;
  }
};

export const getRuleGroupsRequest = async id => {
  try {
    return await projectRequest.get(`/rule_groups/${id}/`);
  } catch (error) {
    throw error;
  }
};

export const partialUpdateRuleGroupsRequest = async (id, data) => {
  try {
    return await projectRequest.patch(`/rule_groups/${id}/`, data);
  } catch (error) {
    throw error;
  }
};

export const updateRuleGroupsRequest = async (id, data) => {
  try {
    return await projectRequest.put(`/rule_groups/${id}/`, data);
  } catch (error) {
    throw error;
  }
};

/* export const updateRuleGroupsItemRequest = async (
  
  groupId,
  itemId,
  data,
) => {
  try {
    return await projectRequest.put(
      `/rule_groups/${groupId}/rules/${itemId}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
}; */

export const deleteRuleGroupRequest = async groupId => {
  try {
    return await projectRequest.delete(`/rule_groups/${groupId}/`);
  } catch (error) {
    throw error;
  }
};
